import { useEffect, useRef } from 'react'
import { YhFormBox } from '@/components/YhFormBoxVertical'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { message } from 'antd'
import { ISelectOptions } from '@/types/AppTypes'
import { YHModal } from '@/components/YHModal'
import { baseVehicleModel } from '../vehicleModel'
import { globalPrompt } from '@/components/message'
import { vehiclePowerList } from '@/types/AppEnums'
import { vehicleService } from '../vehicleService'
import moment from 'moment'
import useGlobalModel from '@/model/globalModel'

export const EditVehicleModal = () => {
    const { editCarVisible, setEditCarVisible, loadData } = baseVehicleModel()
    const formRef = useRef<IYhFormRef>()
    // const [formVal, setFormVal] = useState<any>({})
    const {
        authData,
        user: { userType },
        companyData,
        fleetData,
    } = useGlobalModel(({ user }) => [user])

    const onOk = () => {
        formRef.current?.validateFields().then(async (val) => {
            try {
                let { retData } = await vehicleService.edit({
                    ...editCarVisible.value,
                    ...val,
                    registrationDate: moment(val.registrationDate).format('YYYY-MM-DD'),
                })
                setEditCarVisible({
                    visible: false,
                    value: {},
                })
                message.success(`修改成功！`)
                loadData()
                return retData
            } catch (error) {
                message.warning(error)
            }
        })
    }

    useEffect(() => {
        formRef.current?.setFieldsValue({
            ...editCarVisible.value,
            registrationDate: moment(editCarVisible.value.registrationDate),
        })
    }, [editCarVisible.value])
    const vehiclePowerChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ vehiclePower: value })
    }
    const fleetChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ fleet: value })
    }
    const companyChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ company: value })
    }
    const vehicleSiteChange = (value: string, node: ISelectOptions) => {
        node && saveCache({ fleet: value })
    }
    //保留缓存及回显表单
    const saveCache = (val: { [key: string]: any }) => {
        formRef.current?.setFieldsValue(val)
        // setFormVal({ ...formVal, ...val })
    }

    const formItem: IYhFormItemsBox = {
        title: '',
        style: { padding: '10px', marginBottom: '10px' },
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆牌照',
                fieldName: 'licensePlate',
                span: 24,
                rules: [{ required: true, message: '请输入车辆牌照' }],
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车辆品牌',
                fieldName: 'vehicleBrand',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '车型',
                fieldName: 'vehicleModel',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '发动机号',
                fieldName: 'engineNumber',
                span: 24,
                rules: [{ required: true, message: '请输入发动机号' }],
            },
            {
                type: FormItemTypeEnum.Datepicker,
                fieldLabel: '上牌日期',
                fieldName: 'registrationDate',
                span: 24,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: 'Vin码',
                fieldName: 'vin',
                span: 24,
                rules: [{ required: true, message: '请输入Vin码' }],
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '车辆动力',
                fieldName: 'vehiclePower',
                options: vehiclePowerList,
                span: 24,
                onSelectChange: vehiclePowerChange,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '现场',
                fieldName: 'fleet',
                options: fleetData,
                span: 24,
                onSelectChange: fleetChange,
            },
            {
                type: FormItemTypeEnum.Select,
                fieldLabel: '产权归属公司',
                fieldName: 'company',
                options: companyData,
                span: 24,
                onSelectChange: companyChange,
            },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: '修改人',
                fieldName: 'updateUser',
                span: 24,
            },
            {
                type: userType === '超级管理员' ? FormItemTypeEnum.Select : FormItemTypeEnum.Input,
                fieldLabel: '所属车队',
                fieldName: 'vehicleSite',
                span: 24,
                options: [
                    {
                        label: '全部',
                        value: '',
                        type: '管理员',
                    },
                    ...authData,
                ].filter((item) => item.type === '管理员'),
                onSelectChange: vehicleSiteChange,
                disable: userType !== '超级管理员',
            },
        ],
    }

    const onChange = (changedValues: { [key: string]: any }) => {
        saveCache(changedValues)
    }

    const FromConfig: IYhFormBox<any> = {
        formRef,
        labelAlign: 'right',
        // formValues: formVal,
        onChange,
        boxs: [formItem],
    }
    const onClose = () => {
        globalPrompt('modal', {
            title: '修改车辆',
            type: 'warning',
            text: '您正在修改的车辆记录还没保存...是否关闭？',
            okText: '确认关闭',
            onOk: () =>
                setEditCarVisible({
                    visible: false,
                    value: {},
                }),
            cancelText: '继续修改',
            // onCancel: () => {
            //     formRef.current?.resetFields()
            //     return
            // },
        })
    }
    return (
        <YHModal
            visible={editCarVisible.visible}
            title="您正在修改车辆..."
            cancelText="取消修改"
            okText="确定修改"
            onCancel={onClose}
            onOk={onOk}
            width={500}
            showFooter={true}
        >
            <YhFormBox {...FromConfig} isShowHeader={false} />
        </YHModal>
    )
}
